import React from 'react';
import { styled } from '@compiled/react';
import type { MenuListComponentProps } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { CheckboxData } from '../../../common/ui/user-roles/types';

export type Props = MenuListComponentProps<CheckboxData>;

/**
 * A simplified version of [MenuListContent](src/packages/permissions-administration/pages/users-and-roles/src/common/ui/roles-picker/menu-list/index.tsx)
 */
const DropdownMenuList = (props: Props) => {
	const { children } = props;
	return <MenuListWrapper>{children}</MenuListWrapper>;
};

export default DropdownMenuList;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MenuListWrapper = styled.div({
	margin: `${token('space.100', '8px')} 0`,
});
